<!--//@*/*
    //    *BCS   App v0.91
    //    * Copyright (c) 2025, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
<template>
  <v-app id="admin">
    <auth></auth>
    <brandbar_admin></brandbar_admin>
    <auth></auth>
    <v-container id="users_list" class="mt-10">
      <template>
        <div class="text-center">
          <v-dialog v-model="dialog" width="500" dark>
            <v-card dark>
              <v-card-title class="text-h5 black"> Add Person </v-card-title>

              <v-card-text>
                <template>
                  <v-form ref="form" v-model="frmvalid">
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="3">
                          <v-text-field
                            color="grey lighten-3"
                            v-model="add.firstname"
                            :rules="nameRules"
                            :counter="60"
                            label="First name"
                            required
                            maxlength="60"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="3">
                          <v-text-field
                            color="grey lighten-3"
                            v-model="add.lastname"
                            :rules="nameRules"
                            :counter="60"
                            label="Last name"
                            maxlength="60"
                            required
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-text-field
                            color="grey lighten-3"
                            v-model="add.email"
                            :rules="emailRules"
                            label="E-mail"
                            required
                            maxlength="120"
                            :counter="120"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </template>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#708e92" class="black--text" @click="add_peep">
                  Save
                </v-btn>
                <v-btn
                  text
                  color="#708e92"
                  class="white--text"
                  @click="dialog = false"
                >
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>
      <v-btn
        id="fabadd"
        @click="showdiag"
        class="mx-2"
        fab
        color="red"
        style="position: fixed; bottom: 30px; left: 80%; z-index: 1000"
      >
        <v-icon dark> $plus </v-icon>
      </v-btn>
      <v-row no-gutters>
        <v-col cols="12" md="12" class="users_expansion">
          <!-- Expansion Panels -->
          <v-expansion-panels v-model="panel">
            <!-- names Expansion Panel -->
            <v-expansion-panel class="mb-3">
              <v-expansion-panel-header
                class="users_expansion white--text rounded-b-0 mb-3"
              >
                NIBRS REVIEW ADMIN
                <template v-slot:actions>
                  <v-icon color="white" x-large> $expand </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content color="cmpbkinside">
                <v-row dense>
                  <v-col cols="12" md="12">
                    <h4>Filter</h4>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" md="10">
                    <input
                      id="sterm"
                      type="search"
                      class="pa-2"
                      style="background-color: white; color: black; width: 100%"
                      placeholder="Enter Serach Term >=3 Char"
                    />
                    <div class="search-clear" @click="clear_search">X</div>
                    <!-- <v-text-field
                      clearable
                      @click:clear="sterm = ''"
                      dark
                      dense
                      v-model="sterm"
                      label=""
                      count="20"
                      placeholder="Enter Serach Term >=3 Char"
                    > 
                    </v-text-field> -->
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-btn
                      small
                      color="#708e92"
                      class="black--text"
                      @click="qfind"
                      >Search</v-btn
                    >
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12">
                    <v-btn
                      small
                      color="#708e92"
                      class="black--text"
                      @click="send_emails"
                      >Send Email to all CHECKED</v-btn
                    >
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col>
                    <!-- Card -->
                    <v-card
                      class="mb-3 border-barbexpand person-card"
                      dark
                      elevation="2"
                      outlined
                      v-for="person in lst_persons"
                      :key="person.nibrs_review_peepId"
                    >
                      <v-card-title class="title-name">{{
                        person.name
                      }}</v-card-title>
                      <v-card-text class="card-text">
                        <h6 class="sub-title">Email:</h6>

                        <p>{{ person.email }}</p>
                        <h6 class="sub-title">Last Certification Date</h6>
                        <p>{{ person.last_cert_date }}</p>

                        <!-- SELECT AND BUTTON -->
                        <v-row class="btn-row">
                          <v-col>
                            <div
                              class="submit-btn mt-3 d-flex flex-md-row flex-column justify-md-space-between align-center"
                            >
                              <v-checkbox
                                :id="'chk' + person.nibrs_review_peepId"
                                v-model="person.isChecked"
                                required
                                :color="person.isChecked ? 'grey' : 'greenbtn'"
                              >
                                <template v-slot:label>
                                  <span class="custom-label">Select User</span>
                                </template>
                              </v-checkbox>
                              <v-btn
                                dark
                                class="mb-2 barbexpand black--text"
                                @click="del_prompt(person)"
                                >Delete</v-btn
                              >
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<style lang="scss" scoped>
/* 0 media q */
@media (min-width: 0px) {
  .search-clear {
    width: 40px;
    position: relative;
    top: -37px;
    left: 93.5%;
    font-size: 24px;
    color: black;
    z-index: 500;
  }
  .person-card {
    border-color: #669888;
  }

  .title-name {
    font-size: 1.25rem;
  }

  .sub-title {
    font-size: 1rem;
  }

  .custom-label {
    color: #22f1bf;
    font-size: 1.5rem;
  }
  .btn-row {
    width: 90%;
    margin: 0 auto;
  }

  .users_expansion {
    height: 48px;
    width: 100%;
    margin: 0 auto;
    background-color: #708e92;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
  }

  .users_expansion p {
    font-size: 0.9375rem;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .search-clear {
    width: 40px;
    position: relative;
    top: -37px;
    left: 97%;
    font-size: 24px;
    color: black;
    z-index: 500;
  }
  .users_expansion button {
    font-size: 1.5rem;
  }
  .title-name {
    font-size: 1.75rem;
  }

  .card-text p {
    font-size: 1.5rem;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
}
</style>

<script>
import { bus_common } from "../mixins/bus_common";
import brandbar_admin from "./brandbar_admin.vue";
import auth from "./auth.vue";
export default {
  name: "admin",
  // put 'auth' back inot components
  components: { brandbar_admin, auth },
  mixins: [bus_common],
  data() {
    return {
      frmvalid: false,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length <= 60 || "Name must be less than 60 characters",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      add: {
        firstname: "",
        lastname: "",
        email: "",
      },
      add_new: {
        firstname: "",
        lastname: "",
        email: "",
      },
      dialog: false,
      sterm: "",
      value: "",
      panel: 0,
      valid: false,
      authed: false,
      lst_persons: [],
      select_user: false,
      lst_emails: [],
    };
  },
  computed: {},

  /* METHODS */
  methods: {
    add_peep() {
      console.log("add_peep");
      let self = this;
      if (this.$refs.form.validate() == false) {
        self.swall_it(
          "Add Status",
          "Form Error. Please address the red fields.",
          "warning",
          null,
          null
        );
        return true;
      }

      this.show_loader(true);
      let formIn = {};

      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.peep = this.mno(this.add);

      this.$store
        .dispatch("add_peep", formIn)
        .then((data) => {
          this.show_loader(false);
          if (data.msg.indexOf("already registered") > -1) {
            self.swall_it(
              "Add Status",
              "The email is already registered. Not added.",
              "warning",
              null,
              null
            );
          } else {
            this.dialog = false;
            self.swall_it("Add Status", "Success", "success", null, null);
          }
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error PW", msg, "error", null, null);
        });
    },
    showdiag() {
      this.add = this.mno(this.add_new);
      this.dialog = true;
    },
    send_emails() {
      console.log("send_emails");
      this.lst_emails = this.lst_persons.filter(
        (person) => person.isChecked == true
      );
      let arrIDs = [];
      this.lst_emails.forEach((element) => {
        arrIDs.push(element.nibrs_review_peepId);
      });
      const ids = arrIDs.join(" | ");

      this.show_loader(true);
      let formIn = {};

      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.ids = ids;
      formIn.apiname = "send_emails";

      let self = this;
      this.$store
        .dispatch("send_emails", formIn)
        .then((data) => {
          this.show_loader(false);
          if (data.msg.indexOf("Fail") > -1) {
            self.swall_it("Email Status", data.msg, "error", null, null);
          } else {
            self.swall_it("Email Status", "Success", "success", null, null);
          }
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error PW", msg, "error", null, null);
        });
    },
    clear_search() {
      document.getElementById("sterm").value = "";
    },
    qfind() {
      //  person-card
      let sterm = document.getElementById("sterm").value;
      if (sterm.length >= 3) {
        console.log("is3");
        let lst_card = document.querySelectorAll(".person-card");
        lst_card.forEach((element) => {
          element.style.display = "none";
          if (
            element.innerHTML
              .toLocaleLowerCase()
              .indexOf(sterm.toLocaleLowerCase()) > -1
          ) {
            element.style.display = "block";
          }
        });
      } else {
        console.log("not 3");
        let lst_card = document.querySelectorAll(".person-card");
        lst_card.forEach((element) => {
          element.style.display = "block";
        });
      }
    },

    del_prompt(person) {
      let self = this;
      this.swall_diag(
        "Confirm Delete",
        "You are deleting the User '" +
          person.name +
          "'. Do you wish to continue?",
        "question",
        function () {
          self.delnow(person);
        },
        null,
        null,
        function () {}
      );
    },

    delnow(person) {
      this.show_loader(true);

      var formIn = {};
      formIn.nibrs_review_peepId = person.nibrs_review_peepId;
      formIn.email = this.$store.user.email;

      var self = this;
      this.$store
        .dispatch("delnow", formIn)
        .then((data) => {
          try {
            // Risky operation
            if (data.msg.indexOf("Person not found") > -1) {
              self.swall_it("Delete Status", data.msg, "error", null, null);
              return true;
            }
          } catch (err) {
            console.error("Error:", err.message);
          }
          self.get_peeps();
          self.swall_it("Delete Status", "Success", "success", null, null);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    get_peeps() {
      this.show_loader(true);

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "get_peeps";
      var self = this;
      this.$store
        .dispatch("get_peeps", formIn)
        .then((data) => {
          self.lst_persons = this.mno(data);
          self.lst_persons.forEach((element) => {
            element.last_cert_date = self.format_date_us(
              element.last_cert_date
            );
          });
          self.show_loader(false);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    message1() {
      alert("This button does nothing yet.");
    },

    message2() {
      alert("This button also does nothing yet.");
    },

    init() {
      this.show_loader(true);
      this.get_peeps();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
